import { Box, CircularProgress } from "@mui/material";

interface Props {
  size?: string | number;
}

export const AppSpinner = ({ size = undefined }: Props) => (
  <Box style={{ display: "flex", justifyContent: "center", margin: "3rem 0 3rem 0" }}>
    <CircularProgress size={size} color="secondary" />
  </Box>
);
